export default {
  type: "",
  data: {},
  deleted: {},
  added: {},
  updated: {},
  error: ""
};
